// @ts-strict-ignore
/**
 * @owner @Appboy/clip
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/credit_ratios_detail_data" endpoint
 */
import { isCreditRatiosResult } from "@dashboardApi/apis/creditRatios/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { creditRatios } from "./constants";
import type { CreditRatiosParams, CreditRatiosResult } from "./types";

export const getDataTableCreditRatios = reactQueryTableFetcherAdapter(
  creditRatios,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, sortby, sortdir, start = 0 }: CreditRatiosParams
  ): Promise<CreditRatiosResult> => {
    const { channel_grouping: channelGrouping, destination } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/credit_ratios_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects({
          ...(channelGrouping && { channel_grouping: channelGrouping }),
          ...(destination && { destination: destination }),
        }),
      },
      { signal }
    );
  },
  isCreditRatiosResult
);
